import $ from 'jquery'
import { mapGetters } from 'vuex'
import Editable from '@/components/elements/Editable'
import PrintCover from './PrintCover'
import Multiselect from 'vue-multiselect'
import Nl2br from 'vue-nl2br'
import PrintAllCovers from './PrintAllCovers.vue'
import PrintAllCoversCentral from './PrintAllCoversCentral.vue'
import SendInvoiceBTN from './SendInvoiceBTN.vue'
import api from '@/api'
import { cloneDeep } from 'lodash'
import dayjs from 'dayjs'
import uploadfile from '@/components/elements/uploadfile'
import SelectGmap from './SelectGmap'

export default {
  props: ['value', 'cbAll', 'shippingOptions', 'showProductDetail'],
  data: function() {
    return {
      productsCount: 1,
      pageNumberData: 1,
      dataCheckStatusScgExpress: [],
      showStatusScgExpress: false,
      loadingCheckStatusScg: false,
      hourRange: [],
      minRange: [],
      nowDate: new Date().toISOString().slice(0, 10),
      lalamove_addon_json: null,
      dateTimePreview: null,
      timeHours: null,
      timeMinute: null,
      openStartDate: false,
      shopAddonValueJson: null,
      tax_address_json: null,
      cb: false,
      showDetail: false,
      showPrint: false,
      status: {
        label: this.$t('ordered'),
        value: 'ordered',
        firstinit: true
      },
      shippingValue: '',
      shippingType: null,
      cart_remark: '',
      order: null,
      isEditAddon: null,
      slipUrl: null,
      lalamove: {
        show: false,
        showSummarize: false,
        loading: false,
        order: null,
        date: null,
        totalFee: 0
      },
      showFromAddress: false,
      showToAddress: false,
      timestamp: dayjs().format('x'),
      verifyData: null
    }
  },
  components: {
    Editable,
    PrintCover,
    PrintAllCovers,
    Multiselect,
    Nl2br,
    SendInvoiceBTN,
    PrintAllCoversCentral,
    uploadfile,
    SelectGmap
  },
  computed: {
    pageCountItemOrder() {
      const vm = this
      return Math.ceil(vm.productsCount / 10)
    },
    currencySign() {
      const vm = this
      if (vm.selectedBot.pageid) {
        if (vm.$store.state.poundCurrency.includes(vm.selectedBot.pageid)) {
          return 'GBP'
        } else if (vm.$store.state.usdCurrency.includes(vm.selectedBot.pageid)) {
          return 'USD'
        } else if (vm.$store.state.tkBangladeshCurrency.includes(vm.selectedBot.pageid)) {
          return 'BDT'
        }
      }

      return 'THB'
    },
    editTaxAddress() {
      var data = JSON.parse(this.order.address_json)
      data.tax_address = this.tax_address_json.tax_address
      data.tax_name = this.tax_address_json.tax_name
      data.invoice_date = this.tax_address_json.invoice_date
      data.tax_id = this.tax_address_json.tax_id
      this.order.address_json = JSON.stringify(data)
      this.$emit('updateOrder', { type: 'save', order: this.order })
    },
    isDisableStatus() {
      const vm = this
      if (!vm.status) return false
      if (vm.selectedBot.packhai_status && ['canceled'].includes(vm.status.value)) return true
      if (
        vm.order.trackingno &&
        this.order.shippingtype === 'scgexpress_charge' &&
        vm.selectedBot.scg_express_is_active
      )
        return true
      if (
        vm.selectedBot.jt_express_is_active &&
        vm.order.status == 'canceled' &&
        vm.order.shippingtype === 'jtexpress_charge'
      )
        return true
      return vm.order.egg_crm_phone_no !== null && vm.status.value === 'canceled'
    },
    orderStatusOptions() {
      var options = [
        {
          label: this.$t('pending'),
          value: 'pending'
        },
        {
          label: this.$t('ordered'),
          value: 'ordered'
        },
        {
          label: this.$t('paid'),
          value: 'paid'
        },
        {
          label: this.$t('shipped'),
          value: 'shipped'
        },
        {
          label: this.$t('cancel'),
          value: 'canceled'
        }
      ]

      var optionsEgg = options.filter(e => e.value !== 'shipped')

      if (this.value.status === 'paid') {
        optionsEgg = optionsEgg.filter(e => e.value !== 'ordered')
      }

      if (this.selectedBot.packhai_status && this.value.status == 'shipped') {
        return options.filter(el => ['canceled', 'shipped'].includes(el.value))
      }

      return this.value.egg_crm_phone_no !== null ? optionsEgg : options
    },
    jsonValue() {
      try {
        if (this.order && this.order.jsonvalue) {
          return JSON.parse(this.order.jsonvalue)
        } else {
          return null
        }
      } catch (error) {
        return null
      }
    },
    isCheck() {
      return this.cbAll.includes(this.order.id)
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    shippingAddressPosition() {
      if (this.order.nameaddress && this.order.nameaddress != '') {
        var regex = /[\d.]+?[,][\d.]+/g
        if (this.order.nameaddress.match(regex)) {
          var resultMatch = this.order.nameaddress.match(regex)
          var position = resultMatch[0].split(',')
          if (position.length > 1) {
            return {
              lat: position[0],
              lng: position[1]
            }
          }
        }
      }
      return this.order.nameaddress
    },
    orderDetailFormat: function() {
      var products = ''
      try {
        products = JSON.parse(this.order.productdetail)
        this.productsCount = products.length
        if (['740558886346101'].includes(this.selectedBot.pageid)) {
          const start = (this.pageNumberData - 1) * 10
          const end = start + 10

          products = products.slice(start, end)
        }
        products = products.sort((a, b) => {
          return a.name.localeCompare(b.name)
        })
      } catch (error) {
        products = this.order.productdetail
      }
      try {
        products = products.map(el => {
          if (el.addon_json) {
            el.addon_json = JSON.parse(el.addon_json)
          }
          return el
        })
      } catch (error) {}
      return products
    },
    tags: function() {
      var tags = []
      if (this.order.tags && this.order.tags.trim() != '') {
        tags = this.order.tags.split(',')
      }
      return tags
    },
    loadingdistances() {
      return this.$store.state.loadingdistances
    },
    images() {
      const orderNote = this.order.note
      let images = []

      if (orderNote && typeof orderNote === 'string') {
        images = orderNote.split(';;')
      }

      return images
    }
  },
  mounted() {
    this.reset(this.value)
  },
  methods: {
    async checkStatusScgExpress(orderId) {
      const vm = this
      vm.loadingCheckStatusScg = true
      const data = {
        pageId: vm.selectedBot.pageid,
        orderId: orderId
      }
      let response = await vm.get(
        `scg-express/${data.pageId}/historical-status/${data.orderId}`,
        data
      )

      if (response.success) {
        vm.dataCheckStatusScgExpress = response.result
        vm.showStatusScgExpress = true
      } else {
        vm.$swal.fire({
          title: vm.$t('Unsuccessful'),
          type: 'error'
        })
      }
      vm.loadingCheckStatusScg = false
    },
    checkTime() {
      var H = []
      var M = []
      if (this.lalamove.date === dayjs().format('YYYY-MM-DD')) {
        for (var i = parseInt(dayjs().format('H')); i < 24; i++) {
          H.push(i)
        }
        for (var j = parseInt(dayjs().format('m')); j <= 60; j++) {
          M.push(j)
        }
      }
      this.hourRange = H
      this.minRange = M
    },
    changeTimestamp() {
      this.timestamp = dayjs().format('x')
    },
    changeLocation(type, payload) {
      if (type == 'from') {
        this.lalamove.order.lalamove_info.stops_json[0].location.lat = payload.location.lat.toString()
        this.lalamove.order.lalamove_info.stops_json[0].location.lng = payload.location.lng.toString()
        this.lalamove.order.lalamove_info.stops_json[0].addresses.th_TH.displayString =
          payload.placesinfolabel
      } else if (type == 'to') {
        this.lalamove.order.lalamove_info.stops_json[1].location.lat = payload.location.lat.toString()
        this.lalamove.order.lalamove_info.stops_json[1].location.lng = payload.location.lng.toString()
        this.lalamove.order.lalamove_info.stops_json[1].addresses.th_TH.displayString =
          payload.placesinfolabel
      }
    },
    async onSummaryLalamove() {
      this.lalamove.loading = true
      let lalamove_info = cloneDeep(this.lalamove.order.lalamove_info)
      try {
        let data = {
          serviceType: lalamove_info.service_type,
          stops: lalamove_info.stops_json,
          requesterContact: lalamove_info.requester_contact_json,
          deliveries: lalamove_info.deliveries_json
        }
        if (this.lalamove.date) {
          var timeHours = this.lalamove.time.HH || '00'
          var timeMinute = this.lalamove.time.mm || '00'
          var localISOTime = new Date(
            this.lalamove.date + ' ' + timeHours + ':' + timeMinute + ':' + '00'
          ).toISOString()
          this.dateTimePreview = localISOTime
          data.scheduleAt = localISOTime
        }
        if (this.lalamove.cod) {
          data.specialRequests = ['COD']
        }
        let response = await this.post(`lalamove/${this.selectedBot.pageid}/get-quotation`, data)
        if (response.success && response.result) {
          this.lalamove.totalFee = response.result.totalFee
          this.lalamove.totalFeeCurrency = response.result.totalFeeCurrency
          // notShipping = false
        }
        this.lalamove.showSummarize = true
      } catch (error) {
        console.error(error)
      } finally {
        this.lalamove.loading = false
      }
    },
    onBackLalamove() {
      this.lalamove.showSummarize = false
    },
    async onPlaceOrderLalamove() {
      this.lalamove.loading = true
      let lalamove_info = cloneDeep(this.lalamove.order.lalamove_info)
      if (this.lalamove.cod) {
        lalamove_info.deliveries_json[0].remarks =
          lalamove_info.deliveries_json[0].remarks + ` เก็บเงินปลายทาง ${this.order.amount} บาท`
      }
      let data = {
        serviceType: lalamove_info.service_type,
        stops: lalamove_info.stops_json,
        requesterContact: lalamove_info.requester_contact_json,
        deliveries: lalamove_info.deliveries_json
      }
      if (this.lalamove.date) {
        var timeHours = this.lalamove.time.HH || '00'
        var timeMinute = this.lalamove.time.mm || '00'
        var localISOTime = new Date(
          this.lalamove.date + ' ' + timeHours + ':' + timeMinute + ':' + '00'
        ).toISOString()
        this.dateTimePreview = localISOTime
        data.scheduleAt = localISOTime
      }
      if (this.lalamove.cod) {
        data.specialRequests = ['COD']
      }
      let response = await this.post(
        `lalamove/${this.selectedBot.pageid}/${this.lalamove.order.id}/place-order`,
        data
      )
      if (response.success) {
        this.order.lalamove_info.order_ref = response.result.orderRef
        // response.result
        let result = await this.$swal.fire({
          title: this.$t('Successfully'),
          text: `เลขที่การชำระเงิน: ${response.result.orderRef}`,
          type: 'success'
        })
        if (result.value) {
        }
        // location.reload()
      }

      this.lalamove.show = false
      this.lalamove.showSummarize = false
      this.lalamove.loading = false
    },
    onCancelLalamove() {
      this.lalamove.show = false
      this.lalamove.order = null
    },
    onCreateLalamoveQuotation(order) {
      order = cloneDeep(order)
      try {
        if (
          order.lalamove_info.deliveries_json &&
          typeof order.lalamove_info.deliveries_json == 'string'
        )
          order.lalamove_info.deliveries_json = JSON.parse(order.lalamove_info.deliveries_json)
      } catch (error) {
        console.error(error)
      }
      try {
        if (
          order.lalamove_info.requester_contact_json &&
          typeof order.lalamove_info.requester_contact_json == 'string'
        )
          order.lalamove_info.requester_contact_json = JSON.parse(
            order.lalamove_info.requester_contact_json
          )
      } catch (error) {
        console.error(error)
      }
      try {
        if (
          order.lalamove_info.special_requests_json &&
          typeof order.lalamove_info.special_requests_json == 'string'
        )
          order.lalamove_info.special_requests_json = JSON.parse(
            order.lalamove_info.special_requests_json
          )
      } catch (error) {
        console.error(error)
      }
      try {
        if (order.lalamove_info.stops_json && typeof order.lalamove_info.stops_json == 'string')
          order.lalamove_info.stops_json = JSON.parse(order.lalamove_info.stops_json)
      } catch (error) {
        console.error(error)
      }

      try {
        order.lalamove_info.total_fee = parseInt(order.lalamove_info.total_fee)
      } catch (error) {
        console.error(error)
      }
      if (order.addon_json) {
        this.lalamove_addon_json = JSON.parse(order.addon_json)
        this.lalamove.cod = this.lalamove_addon_json.cod
      }

      this.lalamove.order = order
      this.lalamove.show = true
    },
    goToAllInOneChat(order) {
      var query = { userid: order.userid, app: order.app }
      this.$router
        .push({
          name: 'allinonechat',
          path: '/allinonechat',
          query: query
        })
        .catch(() => {})
    },
    onUploaded(url) {
      const vm = this
      if (vm.order.note) {
        url = `${vm.order.note};;${url}`
      }

      if (vm.verifyData && vm.verifyData.verify_slip_ref) {
        vm.$set(vm.order, 'verify_slip_bank_code', vm.verifyData.verify_slip_bank_code)
        vm.$set(vm.order, 'verify_slip_ref', vm.verifyData.verify_slip_ref)
      }
      vm.$set(vm.order, 'note', url)
      vm.$set(vm.order, 'is_update_slip', true)
      vm.$emit('updateOrder', { type: 'save', order: vm.order })
    },
    onDeleteSlip(image) {
      const images = _(this.order.note)
        .split(';;')
        .filter(_image => _image !== image)
        .join(';;')

      this.$set(this.order, 'note', images)
      this.$emit('updateOrder', { type: 'save', order: this.order })
    },
    editAddon(val) {
      if (this.isEditAddon) {
        this.shopAddonValueJson = cloneDeep(this.cached_addon_value_json)
        this.isEditAddon = null
      }
      this.cached_addon_value_json = cloneDeep(this.shopAddonValueJson)
      this.isEditAddon = val
    },
    cancelAddon() {
      this.shopAddonValueJson = cloneDeep(this.cached_addon_value_json)
      this.isEditAddon = null
    },
    saveAddon() {
      this.cached_addon_value_json = cloneDeep(this.shopAddonValueJson)
      this.order.shop_addon_value_json = JSON.stringify(this.shopAddonValueJson)
      this.$emit('updateOrder', { type: 'save', order: this.order })
      this.isEditAddon = null
    },
    afterReset() {},
    reset(value) {
      this.order = value
      try {
        this.status = this.orderStatusOptions.find(function(element) {
          return element.value == value.status
        })
      } catch (error) {}

      if (this.order.address_json && typeof this.order.address_json === 'string') {
        this.tax_address_json = JSON.parse(this.order.address_json)
        if (!this.tax_address_json.invoice_date) {
          this.tax_address_json.invoice_date = dayjs(this.order.timestamp).format('YYYY-MM-DD')
        }
      }
      if (
        this.order.shop_addon_value_json &&
        typeof this.order.shop_addon_value_json === 'string'
      ) {
        this.shopAddonValueJson = JSON.parse(this.order.shop_addon_value_json)
      }
      this.getShippingType()

      if (
        ['176922345693076', '809510349133469', '103876431747147'].includes(this.selectedBot.pageid)
      ) {
        var order = this.orderDetailFormat.find(el => {
          return el.cart_remark != '' || el.cart_remark != null
        })

        if (order) {
          this.cart_remark = order.cart_remark
        }
      }

      if (this.$store.state.drJillPage.includes(this.selectedBot.pageid)) {
        if (this.order.remark.includes('{|}')) {
          const a = this.order.remark
          this.order.remark = a.split('{|}')[0]
          this.order.employeeId = a.split('{|}')[1]
        }
      }
      this.afterReset()
    },
    getShippingType() {
      var shippingType = ''
      try {
        var jsondata = JSON.parse(this.order.shippingtype)
        shippingType = jsondata.type ? jsondata.type : ''
      } catch (error) {
        shippingType = this.order.shippingtype
      }

      let shipping = shippingType ? shippingType.split('|') : []
      var shippingValue = this.shippingOptions.find(el => {
        return el.name.includes(shipping[0]) || (el[4] && el[4].includes(shippingType))
      })
      this.order['shipName'] = shipping[0]
      this.order['shiptype'] = shipping[1] || ''
      this.shippingValue = shippingValue ? shippingValue.name : ''
      this.shippingType = shippingValue
    },
    async onSelectShipping(val) {
      this.order.shippingtype = val.name
      this.getShippingType()
      // this.$emit('input', this.order)
      await this.$nextTick()
      this.$emit('updateOrder', { type: 'save', order: this.order })
    },
    getOrderById(id) {
      return new Promise((resolve, reject) => {
        api.getordersbyid({ id: id, pageid: this.selectedBot.pageid }, function(error, response) {
          if (error) {
            console.error(error)
            reject(error)
            return
          }

          resolve(response)
        })
      })
    },
    async onPrinCover(allcontents, payload) {
      if (this.order.nameaddress) {
        let orders = []
        if (allcontents) {
          var response = await this.getOrderById(this.order.id)
          orders = response.data ? response.data : []
        } else orders = [this.order]
        payload.printPdf(orders)
      } else {
        await this.$swal.fire({
          title: this.$t('Warning!'),
          text: this.$t('no_delivery_address_warning'),
          type: 'warning',
          confirmButtonText: this.$t('Confirm'),
          reverseButtons: true
        })
      }
    },
    onImageLoadFailure(event) {
      event.target.src = '/static/img/assets/payment/other_charge_logo.png'
    },
    assignCb(id) {
      this.$emit('assignCb', id)
    },
    onConfirmCancelOrder: async function(status) {
      const vm = this
      if (status.value == 'canceled') {
        vm.$swal
          .fire({
            title: vm.$t('do_you_want_cancel_order'),
            text: vm.$t('once_confirmed_the_status_cannot_be_changed_back'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
          .then(async result => {
            if (result.value) {
              vm.onSelectOrderStatus(status)
            } else {
              vm.status = {
                label: this.$t(vm.order.status),
                value: vm.order.status,
                firstinit: false
              }
            }
          })
      } else {
        vm.onSelectOrderStatus(status)
      }
    },
    onSelectOrderStatus: async function(status) {
      const vm = this
      let order = cloneDeep(vm.order)
      if (vm.selectedBot.pageid != '1227843817265057') {
        if (status.value != 'canceled' && order.status == 'canceled') {
          await api.orderstockdelete({ orderid: vm.order.id }, () => {})
        } else if (order.status != 'canceled' && status.value == 'canceled') {
          await api.orderstockadd({ orderid: vm.order.id }, () => {})
        }
      }

      if (vm.selectedBot.packhai_status) {
        if (order.status != 'shipped' && status.value == 'shipped') {
          if (
            [
              'bestexpress_charge',
              'kerry_charge',
              'ems_charge',
              'nim_charge',
              'flash_charge',
              'scgexpress_charge',
              'jtexpress_charge',
              'cod_charge'
            ].includes(order.shippingtype)
          ) {
            // เปลี่ยนสถานะแล้วส่ง order ให้ packhai
            let is_cod = order.shippingtype == 'cod_charge'

            let body = {
              orderid: vm.order.id
            }

            if (is_cod) {
              const { value: shippingtype } = await vm.$swal.fire({
                title: 'Select shipping for cod',
                input: 'select',
                inputOptions: {
                  bestexpress_charge: vm.$t('bestexpress_charge'),
                  kerry_charge: vm.$t('kerry_charge'),
                  ems_charge: vm.$t('ems_charge'),
                  nim_charge: vm.$t('nim_charge'),
                  flash_charge: vm.$t('flash_charge'),
                  scgexpress_charge: vm.$t('scgexpress_charge'),
                  jtexpress_charge: vm.$t('jtexpress_charge')
                },
                inputPlaceholder: 'Select a shipping for cod',
                showCancelButton: true,
                reverseButtons: true,
                confirmButtonText: vm.$t('Confirm'),
                cancelButtonText: vm.$t('cancel')
              })
              body.new_shipping_type = shippingtype
            }

            let response = await api.post_packhai_create_new_order({
              body: body,
              params: {
                pageid: vm.selectedBot.pageid
              }
            })
            if (response.success && response.result && response.result.packhai_info) {
              vm.$set(order, 'packhai_ref', response.result.packhai_info.orderID)
            }
          } else {
            await vm.$swal.fire({
              type: 'error',
              title: vm.$t('ขนส่งของออเดอร์นี้ไม่สารมารถส่งกับ Packhai ได้')
            })
          }
        } else if (order.status != 'shipped' && status.value == 'canceled') {
          // ยกเลิกการส่งสินค้า กับ packhai
          await api.delete_packhai_cancel_order({
            body: {
              orderid: vm.order.id
            },
            params: {
              pageid: vm.selectedBot.pageid
            }
          })
        }
      }
      if (vm.selectedBot.sokochan_info && vm.selectedBot.sokochan_info.status) {
        if (order.status != 'shipped' && status.value == 'shipped') {
          // เปลี่ยนสถานะแล้วส่ง order ให้ sokochan

          let body = {
            orderid: vm.order.id
          }

          let response = await api.post_sokochan_create_new_order({
            body: body,
            params: {
              pageid: vm.selectedBot.pageid
            }
          })
          if (response.success && response.result && response.result.sokochan) {
            vm.$set(order, 'sokochan_ref', response.result.sokochan.orderID)
          }
        } else if (order.status != 'shipped' && status.value == 'canceled') {
          // ยกเลิกการส่งสินค้า กับ sokochan
          await api.delete_sokochan_cancel_order({
            body: {
              orderid: vm.order.id
            },
            params: {
              pageid: vm.selectedBot.pageid
            }
          })
        }
      }

      if (
        vm.selectedBot.jt_express_is_active &&
        order.status === 'shipped' &&
        order.shippingtype === 'jtexpress_charge' &&
        status.value === 'canceled'
      ) {
        let alert = await vm.$swal.fire({
          title: vm.$t('Warning!'),
          text: vm.$t('การยกเลิกออเดอร์ จะยกเลิกจากระบบ J&T ด้วย'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        if (alert.value) {
          await vm.post(`jt-express/${vm.selectedBot.pageid}/cancel-order`, {
            order_id: vm.order.id
          })
          vm.$set(order, 'status', status.value)
          vm.$emit('updateOrder', { type: 'save', order })
        } else {
          vm.$set(order, 'status', vm.order.status)
          vm.$emit('updateOrder', { type: 'save', order })
        }
      } else {
        vm.$set(order, 'status', status.value)
        vm.$emit('updateOrder', { type: 'save', order })
      }
    },
    formatCurrency(number, currency) {
      currency = currency || this.currencySign

      return Intl.NumberFormat('th-TH', {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol'
      }).format(number)
    }
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal != oldVal) {
        this.reset(newVal)
      }
    },
    cbAll(newVal) {
      if (this.cbAll.includes(newVal.id)) this.cb = true
      else this.cb = false
    },
    showPrint: function(newVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/template/ecommerce/OrderSummaryItem.js